// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type BulletedList24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const BulletedList24: FC<BulletedList24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M9 19v-2h12v2H9Zm0-6v-2h12v2H9Zm0-6V5h12v2H9ZM5 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 18c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 16c.55 0 1.02.196 1.412.587C6.804 16.98 7 17.45 7 18s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 5 20Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 12c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 10c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 14Zm0-6c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 3 6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4c.55 0 1.02.196 1.412.588C6.804 4.979 7 5.45 7 6c0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 5 8Z" />
        </svg>
    );
};

export default BulletedList24;
